module.exports = __webpack_public_path__ + "static/cla-992b68674065219591cedfc599cb2f9c.svg";